import React from "react";
import { LoginForm } from "../forms/LoginForm";
import {Navigation} from "../components/web/Navigation";

// Define a type for the component if it has props, otherwise React.FC is fine.
// Since Login has no props currently, React.FC is sufficient.
const Login: React.FC = () => {
  return (
    <>
      <Navigation />
      <main className="main-wrapper">
        <LoginForm />
      </main>
    </>
  );
};

export default Login;
